import type { OfflineManifest } from '@floorfile/contracts'
/** D24 owner declaration: HR PII is NEVER cached offline (doc §8,
 * OFFLINE_&_MOBILE_RESILIENCE.md §9) — every surface requires the server. */
export const hrRecordsOfflineManifest: OfflineManifest = {module:'hr_records',entities:['hr_record'],actions:[],conflictPolicy:'server-review-required',requiresOnline:['read','create','issue','acknowledge','decline','escalate','close'],neverCache:true}
